import { render, staticRenderFns } from "./ScreenshotCard.vue?vue&type=template&id=334a1f45&scoped=true"
import script from "./ScreenshotCard.vue?vue&type=script&lang=js"
export * from "./ScreenshotCard.vue?vue&type=script&lang=js"
import style0 from "./ScreenshotCard.vue?vue&type=style&index=0&id=334a1f45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334a1f45",
  null
  
)

export default component.exports